import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet, Router, ActivatedRoute } from '@angular/router';
import { NgClass } from '@angular/common';
import { TopBarWrapperComponent, DashboardType } from '../top-bar-wrapper/top-bar-wrapper.component';
import { MessagingRoutePaths, RoutePaths } from '../../shared/types/common';
import { AssetVersionPipe } from '../../pipes/asset-version.pipe';

@Component({
  selector: 'app-messaging-screen',
  imports: [TopBarWrapperComponent, RouterOutlet, NgClass, AssetVersionPipe],
  templateUrl: './messaging-screen.component.html',
  styleUrl: './messaging-screen.component.scss'
})
export class MessagingScreenComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  protected readonly DashboardType = DashboardType;
  protected readonly MessagingRoutePaths = MessagingRoutePaths;
  public isGalleryHovered = false;

  public activeTab = signal<string>(MessagingRoutePaths.MARKETING_REPORT);

  ngOnInit(): void {
    const segments = this.router.url.split('/');
    const tab = segments[segments.indexOf(RoutePaths.MESSAGING) + 1];
    this.activeTab.set(tab || MessagingRoutePaths.MARKETING_REPORT);
  }

  navigateTo(tab: MessagingRoutePaths): void {
    if (this.activeTab() !== tab) {
      this.activeTab.set(tab);
      this.router.navigate([tab], { relativeTo: this.route });
    }
  }
}